export const GET_LOOKUP_EVALUATION_TIME_REQUEST = 'GET_LOOKUP_EVALUATION_TIME_REQUEST';
export const GET_LOOKUP_EVALUATION_TIME_SUCCESS = 'GET_LOOKUP_EVALUATION_TIME_SUCCESS';

export const SET_COMET_LOOKUPS = 'SET_COMET_LOOKUPS';
export const DISPOSE = 'APP_DISPOSE_STORE';
